import { render } from "./AbsenceWithoutWarning.vue?vue&type=template&id=28aecae4"
import script from "./AbsenceWithoutWarning.vue?vue&type=script&lang=js"
export * from "./AbsenceWithoutWarning.vue?vue&type=script&lang=js"

import "./AbsenceWithoutWarning.vue?vue&type=style&index=0&id=28aecae4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__